import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-15b9dbb0")

_pushScopeId("data-v-15b9dbb0")
const _hoisted_1 = { class: "chat__header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "chat__main" }
const _hoisted_5 = { class: "chat__users" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h3", null, "참여자", -1)
const _hoisted_7 = { class: "user-list" }
const _hoisted_8 = {
  class: "chat__messages",
  ref: "messageViewer$"
}
const _hoisted_9 = { class: "item--content" }
const _hoisted_10 = { class: "message--info" }
const _hoisted_11 = { class: "item--title" }
const _hoisted_12 = { class: "item--datetime" }
const _hoisted_13 = { class: "chat__footer" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("send")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (!!_ctx.state.id)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: _ctx.state.visibility ? 'video__chat--open' : 'video__chat'
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_Button, { onClick: _ctx.toggleChat }, {
            default: _withId(() => [
              (_ctx.state.visibility)
                ? (_openBlock(), _createBlock("span", _hoisted_2, "닫기"))
                : (_openBlock(), _createBlock("span", _hoisted_3, "채팅"))
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("ul", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messages.participant, (user, index) => {
                return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(user.PersonName), 1))
              }), 128))
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messages.filterMessages, (message) => {
              return (_openBlock(), _createBlock("div", {
                key: message.Key,
                class: message.isMine ? 'message -mine' : 'message'
              }, [
                _createVNode(_component_Card, null, {
                  content: _withId(() => [
                    _createVNode("span", _hoisted_9, _toDisplayString(message.Message), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode("div", _hoisted_10, [
                  _createVNode("span", _hoisted_11, _toDisplayString(message.Name), 1),
                  _createVNode("span", _hoisted_12, _toDisplayString(_ctx.splitDatetimeStringToString(message.DateTime)), 1)
                ])
              ], 2))
            }), 128))
          ], 512)
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
          }, [
            _withDirectives(_createVNode("input", {
              placeholder: "메시지",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newMessage = $event))
            }, null, 512), [
              [_vModelText, _ctx.newMessage]
            ]),
            _createVNode(_component_Button, {
              class: "send-button",
              type: "submit"
            }, {
              default: _withId(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ], 32)
        ])
      ], 2))
    : _createCommentVNode("", true)
})